import S from 's-js';

import { Berth } from './Berth';
import { Measurement } from './Measurement';

// PierMark was a computed field in C#, but with the C# -> JSON -> observable mapping, we lost that
// we create functions here to convert them back, extending Measurement to get its methods
export class PierMark extends Measurement {
    constructor(footmark : Measurement, berth : () => Berth | null) {
        super();

        this.Num = function (v? : number) {
            if (v === undefined) {
                const b = berth();
                return b ? b.PierMark.subtract(b.StartMark).add(footmark).Num() : footmark.Num();
            } else {
                S.sample(() => {
                    const b = berth();
                    footmark.Num(b ?
                        new Measurement({ Num: v, UOM: b.PierMark.UOM() })
                            .subtract(b.PierMark)
                            .add(b.StartMark)
                            .convert(footmark.UOM())
                            .Num() :
                        v
                    );
                });
                return v;
            }
        };

        this.UOM = () => berth()?.PierMark.UOM() ?? footmark.UOM();
    }
}



// WEBPACK FOOTER //
// ./data/models/PierMark.ts